import { useState } from 'react';
import { Accordion } from '../components/Accordion';
import {
  backgroundOptions,
  styleOptions,
  selectOptions,
  currentAppearance,
  defaultAppearance,
  saveAppearance,
  type Appearance,
} from '../appearance';

function PreviewChoices({
  name,
  title,
  value,
  onChange,
}: {
  name: 'background' | 'style';
  title: string;
  value: Appearance;
  onChange: (value: Appearance) => void;
}) {
  const options = name === 'background' ? backgroundOptions : styleOptions;
  return (
    <fieldset className="appearance-choices">
      <legend data-search-id={`appearance-${name}`} id={`appearance-${name}`}>
        {title}
      </legend>
      <div className="appearance-grid">
        {options.map((option) => (
          <button
            key={option.id}
            type="button"
            className="btn appearance-choice"
            aria-pressed={value[name] === option.id}
            onClick={() => onChange({ ...value, [name]: option.id })}
          >
            <span
              aria-hidden="true"
              className="appearance-preview"
              data-background={name === 'background' ? option.id : value.background}
              data-style={name === 'style' ? option.id : value.style}
            >
              <span className="appearance-preview-card">
                <span />
                <span />
              </span>
            </span>
            {option.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
export function AppearanceSection() {
  const [value, setValue] = useState(currentAppearance);
  const [message, setMessage] = useState('');
  function change(next: Appearance) {
    const saved = saveAppearance(next);
    setValue(currentAppearance());
    setMessage(saved ? '表示設定を保存しました。' : '保存できないため、既定の表示設定を使います。');
  }
  function select(name: keyof typeof selectOptions, title: string) {
    return (
      <div className="field">
        <label htmlFor={`appearance-${name}`}>{title}</label>
        <select
          data-search-id={`appearance-${name}`}
          id={`appearance-${name}`}
          className="input"
          value={value[name]}
          onChange={(event) => change({ ...value, [name]: event.target.value })}
        >
          {selectOptions[name].map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
  return (
    <Accordion title="表示" summary="外観・テーマ・文字の大きさ" headingLevel={2} storageKey="settings:appearance">
      {select('mode', '表示モード')}
      <PreviewChoices name="background" title="背景のテーマ" value={value} onChange={change} />
      {select('accent', 'アクセント色')}
      <PreviewChoices name="style" title="スタイル" value={value} onChange={change} />
      {select('density', '密度')}
      {select('fontSize', '文字の大きさ')}
      {select('motion', '動き')}
      <p className="small muted">
        変更はすぐに反映し、このブラウザに保存します。自動では端末の表示モードに合わせます。
      </p>
      <div className="row">
        <button className="btn" type="button" onClick={() => change(defaultAppearance())}>
          初期設定に戻す
        </button>
      </div>
      {message && <p role="status">{message}</p>}
    </Accordion>
  );
}
